import { IChannel, ModelSearchType } from '@/models/channel.model';

export const getChannelModelSearchType = (channel: IChannel) => {
  const { hideModelYearRange, hideSerialNumber } = channel;

  if (hideModelYearRange && hideSerialNumber) {
    return ModelSearchType.NOTHING;
  }

  if (hideModelYearRange) {
    return ModelSearchType.SERIAL_NUMBER;
  }

  if (hideSerialNumber) {
    return ModelSearchType.DATES;
  }

  return ModelSearchType.NOTHING;
};
